import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Home from './pages/Home';

import { ROUTES } from './constants/routes.constants';

export default function Routes() {
  return (
    <Switch>
      <Route path={ROUTES.HOME} exact component={Home} />
    </Switch>
  );
}
